import { CounterOffer } from '../../../../providers/api/dtos';
import { removeNullAndUndefinedValues } from '../../../../utils/array';
import { isEmpty } from '../../../../utils/object/object';
import { CounterOfferFormModel } from './CounterOfferForm';

export const counterOfferFormModelToCounterOffer = (formValues: CounterOfferFormModel): CounterOffer | undefined => {
  const amendments = removeNullAndUndefinedValues(formValues.contractAmendments.map(({ value }) => value.trim() || undefined));

  const counterOffer: CounterOffer = {
    value: formValues.value ? Number(formValues.value) : undefined,
    contractAmendments: amendments.length > 0 ? amendments : undefined,
  };

  return isEmpty(counterOffer) ? undefined : counterOffer;
};

export const counterOfferToCounterOfferFormModel = (counterOffer: CounterOffer = {}): Partial<CounterOfferFormModel> => ({
  isValueChanged: '',
  value: '',
  contractAmendments: counterOffer.contractAmendments?.map((am, i) => ({
    key: i.toString(),
    value: am,
  })) || [],
});
